import Vue from 'vue'

/**
 * 回款记录查询
 * @param data
 * @returns {*}
 */
export function getPayRecordList(data) {
    return Vue.axios({
        url: '/api/pay_record/list',
        method: 'post',
        data: { ...data }
    })
}

/**
 * 销售回款记录查询
 * @param data
 * @returns {*}
 */
export function getMyPayRecordList(data) {
    return Vue.axios({
        url: '/api/pay_record/my_records',
        method: 'post',
        data: { ...data }
    })
}

export function getPayRecordDetail(data) {
    return Vue.axios({
        url: '/api/pay_record/detail',
        method: 'post',
        data: { ...data }
    })
}

//seller_orders
/**
 * 销售订单查询
 * @param data
 * @returns {*}
 */
export function getSellerOrders(data) {
    return Vue.axios({
        url: '/api/pay_record/seller_orders',
        method: 'post',
        data: { ...data }
    })
}

/**
 * 回款记录认领
 * @param data
 * @returns {*}
 */
export function tickPayRecord(data) {
    return Vue.axios({
        url: '/api/pay_record/tick',
        method: 'post',
        data: { ...data }
    })
}

/**
 * 回款记录确认信息查询
 * @param data
 * @returns {*}
 */
export function getPaySheets(data) {
    return Vue.axios({
        url: '/api/pay_record/get_pay_sheets',
        method: 'post',
        data: { ...data }
    })
}

/**
 * 回款确认（认领的回款记录）
 * @param data
 * @returns {*}
 */
export function checkPaySheets(data) {
    return Vue.axios({
        url: '/api/pay_record/check_pay_sheet',
        method: 'post',
        data: { ...data }
    })
}

/**
 * 撤回-回款确认（认领的回款记录）
 * @param data
 * @returns {*}
 */
export function cancelCheckPaySheets(data) {
    return Vue.axios({
        url: '/api/pay_record/check_cancel',
        method: 'post',
        data: { ...data }
    })
}

/**
 * 撤销-回款记录
 * @param data
 * @returns {*}
 */
export function cancelPayRecord(data) {
    return Vue.axios({
        url: '/api/pay_record/cancel',
        method: 'post',
        data: { ...data }
    })
}

/**
 * 撤销回款确认记录-认领
 * @param data
 * @returns {*}
 */
export function cancelPaySheet(data) {
    return Vue.axios({
        url: '/api/pay_record/cancel_sheet',
        method: 'post',
        data: { ...data }
    })
}